/**
 * Created by jpilz on 2/13/17.
 */
import _ from 'lodash';

export default class profileObj {

    constructor() {

        console.log("profileObj:constructor:");

        this.modelName = "profileObj";

        this.ApplicationId = "";
        this.ApplicationName = "";
        this.JsonPropertyUpdates = "";
        this.LoggedInUserName = "";
        this.UpdateProperty = "";
        this.UpdatePropertyLocation = "";
        this.UserId = "";
        this.UserName = "";
        this.UserProfileJSON = "";
        this.UserProfileTypeId = "";
        this.defaultLoaded = false;

        this.CheckProfile();

    }

    init(data) {

        console.log("profileObj:init: data: %o", data);

        this.ApplicationId = data.ApplicationId;
        this.ApplicationName = data.ApplicationName;
        this.JsonPropertyUpdates = data.JsonPropertyUpdates;
        this.LoggedInUserName = data.LoggedInUserName;
        this.UpdateProperty = data.UpdateProperty;
        this.UpdatePropertyLocation = data.UpdatePropertyLocation;
        this.UserId = data.UserId;
        this.UserName = data.UserName;
        this.UserProfileJSON = JSON.parse(data.UserProfileJSON);
        this.UserProfileTypeId = data.UserProfileTypeId;
        this.defaultLoaded = false;

        this.CheckProfile();
    }

    CheckProfile() {

       console.log("profileObj:CheckProfile: this.UserProfileJSON isEmpty %o", _.isEmpty(this.UserProfileJSON));

        if(_.isEmpty(this.UserProfileJSON))
        {
            console.log("profileObj:CheckProfile: Loding default Profile");
            this.defaultLoaded = true;
            this.UserProfileJSON = this.setDefaultProfile();
        }
    }

    setDefaultProfile() {
        this.defaultLoaded = true;
        return {disableExpertOptions: true};
    }
 

}




// WEBPACK FOOTER //
// ./src/objects/profileObj.js